import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changePackingOrderId = createAction('CHANGE_PACKING_ORDERID');
export const changePackingEventKey = createAction('CHANGE_PACKING_EVENT_KEY');
export const changePackingItemActivePage = createAction('CHANGE_PACKING_ITEM_ACTIVE_PAGE');

export const findPackingItemList = (payload, pagingData) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let boxNumber = payload.boxNumber;
      let boxNumberStr = '';
      if (boxNumber && !('' === boxNumber)) {
        boxNumberStr = '/' + boxNumber;
      }
      let url = '/firefighter/gear/packing/' + payload.orderId + '/findPackingItemList' + boxNumberStr + '?activePage='
        + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage;
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_PACKING_ITEM_LIST',
          payload: json
        });
      });
    }
  }
);

export const findUnPackingItemCount = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let url = '/firefighter/gear/packing/' + payload.orderId + '/findUnPackingItemCount';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_UNPACKING_ITEMS_COUNT',
          payload: json
        });
      });
    }
  }
);

export const findPackingBoxNumbers = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let url = '/firefighter/gear/packing/' + payload.orderId + '/findBoxNumbers';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_PACKING_BOX_NUMBERS',
          payload: json
        });
      });
    }
  }
);

export const findDistinctCategories = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let url = '/firefighter/gear/packing/' + payload.orderId + '/findDistinctCategories';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_DISTINCT_CATEGORYIES',
          payload: json
        });
      });
    }
  }
);

export const changePackingBySystemBeanValue = createAction('CHANGE_PACKINGBYSYSTEMBEAN_VALUE');

export const packingItems = (packingBySystemBean, pagingData) => (
  (dispatch) => {
    let orderId = packingBySystemBean.get('orderId');
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/gear/packing/' + orderId + '/packingItems';
      authFetch('PUT', url, JSON.stringify(packingBySystemBean), (json) => {
        dispatch({
          type: 'PACKING_ITEMS',
          payload: json
        });
        dispatch(findPackingItemList({
          orderId: orderId
        }, pagingData));
        dispatch(findUnPackingItemCount({
          orderId: orderId
        }));
        dispatch(findPackingBoxNumbers({
          orderId: orderId
        }));
      });
    } else {
      let url = '/firefighter/fitting/defaultValidateFail';
      let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
      authFetch('PUT', url, JSON.stringify(payload), (json) => {
        dispatch({
          type: 'PACKING_DEFAULT_VALIDATE_FAIL',
          payload: json
        });
      });
    }
  }
);

export const openPackingBoxNumberModal = createAction('OPEN_PACKING_BOX_NUMBER_MODAL');
export const closePackingBoxNumberModal = createAction('CLOSE_PACKING_BOX_NUMBER_MODAL');

export const findPackingItem = (payload, pk) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let url = '/firefighter/gear/packing/' + payload.orderId + '/items/' + pk.order_item_id;
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_PACKING_ITEM',
          payload: json
        });
      });
    }
  }
);

export const changePackingItemValue = createAction('CHANGE_PACKINGITEM_VALUE');
export const changeShippingLabelValue = createAction('CHANGE_SHIPPINGLABEL_VALUE');

export const editPackingBoxNumber = (packingItemBean, pagingData) => (
  (dispatch) => {
    let orderId = packingItemBean.get('orderId');
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/gear/packing/' + orderId + '/editBoxNumber';
      authFetch('PUT', url, JSON.stringify(packingItemBean), (json) => {
        dispatch({
          type: 'EDIT_PACKING_BOX_NUMBER',
          payload: json
        });
        dispatch(findPackingItemList({
          orderId: orderId
        }, pagingData));
        dispatch(findUnPackingItemCount({
          orderId: orderId
        }));
        dispatch(findPackingBoxNumbers({
          orderId: orderId
        }));
      });
    }
  }
);

export const findShippingLabel = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let url = '/firefighter/gear/packing/' + payload.orderId + '/findShippingLabel/' + payload.boxNumber;
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_SHIPPING_LABEL',
          payload: json
        });
      });
    }
  }
);

export const editShippingBoxLabel = (shippingLabel) => (
  (dispatch) => {
    let orderId = shippingLabel.get('orderId');
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/gear/packing/' + orderId + '/editShippingBoxLabel';
      authFetch('PUT', url, JSON.stringify(shippingLabel), (json) => {
        dispatch({
          type: 'EDIT_SHIPPING_BOX_LABEL',
          payload: json
        });
      });
    } else {
      let url = '/firefighter/fitting/defaultValidateFail';
      let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
      authFetch('PUT', url, JSON.stringify(payload), (json) => {
        dispatch({
          type: 'PACKING_DEFAULT_VALIDATE_FAIL',
          payload: json
        });
      });
    }
  }
);

export const clearPackingItems = (shippingLabel, pagingData) => (
  (dispatch) => {
    let orderId = shippingLabel.get('orderId');
    if (orderId && !('' === orderId)) {
      let boxNumber = shippingLabel.get('boxNumber');
      if (boxNumber && !('' === boxNumber)) {
        let url = '/firefighter/gear/packing/' + orderId + '/clearPackingItems/' + boxNumber;
        authFetch('DELETE', url, JSON.stringify(shippingLabel), (json) => {
          dispatch({
            type: 'CLEAR_PACKING_ITEMS',
            payload: json
          });
          dispatch(findPackingItemList({
            orderId: orderId
          }, pagingData));
          dispatch(findUnPackingItemCount({
            orderId: orderId
          }));
          dispatch(findPackingBoxNumbers({
            orderId: orderId
          }));
        });
      }
    } else {
      let url = '/firefighter/fitting/defaultValidateFail';
      let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
      authFetch('PUT', url, JSON.stringify(payload), (json) => {
        dispatch({
          type: 'PACKING_DEFAULT_VALIDATE_FAIL',
          payload: json
        });
      });
    }
  }
);

export const clearAllPackingItems = (shippingLabel, pagingData) => (
  (dispatch) => {
    let orderId = shippingLabel.get('orderId');
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/gear/packing/' + orderId + '/clearAllPackingItems';
      authFetch('DELETE', url, JSON.stringify(shippingLabel), (json) => {
        dispatch({
          type: 'CLEAR_PACKING_ITEMS',
          payload: json
        });
        dispatch(findPackingItemList({
          orderId: orderId
        }, pagingData));
        dispatch(findUnPackingItemCount({
          orderId: orderId
        }));
        dispatch(findPackingBoxNumbers({
          orderId: orderId
        }));
      });
    } else {
      let url = '/firefighter/fitting/defaultValidateFail';
      let payload = { displayMessage: '驗證失敗:訂單編號不存在' };
      authFetch('PUT', url, JSON.stringify(payload), (json) => {
        dispatch({
          type: 'PACKING_DEFAULT_VALIDATE_FAIL',
          payload: json
        });
      });
    }
  }
);

export const clearPackingAlert = createAction('CLEAR_PACKING_ALERT');


// WEBPACK FOOTER //
// ./src/actions/packingActions.js